import {
  faAddressBook,
  faGaugeHigh,
  faAddressCard,
  faArrowRightArrowLeft,
  faArrowRightFromBracket,
  faArrowsRotate,
  faArrowUpRightFromSquare,
  faBarcode,
  faBarcodeScan,
  faBoxArchive,
  faBoxCheck,
  faBoxOpen,
  faBug,
  faBuilding,
  faBuildings,
  faBullseye,
  faCalendar,
  faCalendarClock,
  faCheck,
  faCheckToSlot,
  faCircleQuestion,
  faCircleXmark,
  faClipboardList,
  faClipboardListCheck,
  faClipboardUser,
  faClone,
  faCodePullRequest,
  faCommentsDollar,
  faCommentsQuestion,
  faConveyorBelt,
  faConveyorBeltBoxes,
  faCopy,
  faCow,
  faDiagramVenn,
  faDiamondExclamation,
  faDownload,
  faEnvelope,
  faEnvelopeOpen,
  faExclamationCircle,
  faFaceThermometer,
  faFileChartColumn,
  faFileContract,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileLines,
  faFileExport,
  faFilter,
  faFlagPennant,
  faFolder,
  faGear,
  faGlobe,
  faGrid,
  faHandshake,
  faHouse,
  faIdBadge,
  faListCheck,
  faListDropdown,
  faLock,
  faLockOpen,
  faMailBulk,
  faMemo,
  faMoneyCheck,
  faMonkey,
  faNote,
  faPencil,
  faPersonRunning,
  faPhone,
  faPresentation,
  faPrint,
  faRotateLeft,
  faScanner,
  faServer,
  faSnooze,
  faSpinnerThird,
  faSquareThisWayUp,
  faStar as faStarDuo,
  faTable,
  faTags,
  faTasks,
  faTimes,
  faToggleOff,
  faToggleOn,
  faTrashCanXmark,
  faTruck,
  faTruckClock,
  faTruckFront,
  faTruckPickup,
  faTruckRampBox,
  faUpload,
  faUserGroup,
  faUsers,
  faUserTag,
  faUserTie,
  faUserTieHair,
  faWarehouseFull,
  faPager,
  faLayerGroup,
  faShare,
} from "@fortawesome/pro-duotone-svg-icons"

import {
  faArrowDownWideShort,
  faArrowLeft,
  faArrowLeftLong,
  faArrowRight,
  faArrowRightLong,
  faArrowUpWideShort,
  faBars,
  faBlockQuote,
  faBookCopy,
  faBoxes,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronsLeft,
  faChevronsRight,
  faChevronUp,
  faCircleCheck,
  faCircleMinus,
  faCodeMerge,
  faCommentLines,
  faCrateEmpty,
  faEllipsis,
  faEye,
  faEyeSlash,
  faFile,
  faFileExcel,
  faFilePdf,
  faFilePlus,
  faFingerprint,
  faFloppyDisk,
  faFloppyDiskCircleArrowRight,
  faGripLines,
  faImage,
  faInboxIn,
  faInboxOut,
  faInfoSquare,
  faKey,
  faLink,
  faLinkHorizontalSlash,
  faList,
  faLocationArrow,
  faLocationDot,
  faMagnifyingGlass,
  faMinus,
  faMobileScreen,
  faMoneyBill,
  faNetworkWired,
  faObjectGroup,
  faObjectsAlignBottom,
  faPersonDolly,
  faPhoneArrowDownLeft,
  faPlus,
  faRightToBracket,
  faSlidersUp,
  faStar,
  faStickyNote,
  faText,
  faTimes as faTimesSolid,
  faTools,
  faTriangleExclamation,
  faUser,
  faUserCircle,
  faVideo,
  faXmark,
  faSplit,
  faMoneyBill1,
  faBell as faBellSolid,
  faShoppingCart as faCartShoppingSolid,
} from "@fortawesome/pro-solid-svg-icons"

import {
  faBell,
  faBoxOpen as faBoxOpenRegular,
  faCartShopping,
  faClipboardList as faClipboardListRegular,
  faRectangleHistory,
  faTruckFast,
  faUsersViewfinder,
  faChevronLeft as faChevronLeftRegular,
  faChevronRight as faChevronRightRegular,
  faPhone as phoneRegular,
} from "@fortawesome/pro-regular-svg-icons"

export const icons = {
  back: faArrowLeft,
  snooze: faSnooze,
  sentEmail: faInboxOut,
  receivedEmail: faInboxIn,
  calendar: faCalendar,
  truck: faTruck,
  truckZoom: faTruckFast,
  sortUp: faArrowUpWideShort,
  sortDown: faArrowDownWideShort,
  money: faMoneyBill,
  specialItem: faStar,
  regularItem: faStarDuo,
  tableView: faList,
  clipboardList: faClipboardListRegular,
  location: faLocationDot,
  gridView: faGrid,
  clients: faUserCircle,
  collapse: faMinus,
  summary: faBlockQuote,
  orders: faFileContract,
  quotes: faCommentsDollar,
  deliveries: faPersonDolly,
  invoices: faFileInvoice,
  key: faKey,
  videos: faVideo,
  importer: faScanner,
  customers: faUsers,
  download: faDownload,
  upload: faUpload,
  addresses: faAddressCard,
  drivers: faTruckFront,
  purchaseOrders: faFileInvoiceDollar,
  users: faUserGroup,
  usersExternal: faUserTag,
  usersInternal: faUserTie,
  products: faBoxCheck,
  suppliers: faHandshake,
  help: faCircleQuestion,
  new: faPlus,
  archive: faBoxArchive,
  save: faFloppyDisk,
  saveAndPreview: faFloppyDiskCircleArrowRight,
  branches: faBuilding,
  importerLogs: faBarcodeScan,
  debug: faBug,
  databasePerformance: faGaugeHigh,
  home: faHouse,
  settings: faGear,
  duplicate: faClone,
  edit: faPencil,
  copy: faCopy,
  external: faArrowUpRightFromSquare,
  menu: faBars,
  alert: faDiamondExclamation,
  spinner: faSpinnerThird,
  arrowLeft: faArrowLeft,
  arrowRight: faArrowRight,
  fulfillments: faTruckRampBox,
  check: faCheck,
  info: faInfoSquare,
  delete: faTrashCanXmark,
  search: faMagnifyingGlass,
  mail: faEnvelope,
  sageImports: faServer,
  refresh: faArrowsRotate,
  lock: faLock,
  lockOpen: faLockOpen,
  cross: faXmark,
  grip: faGripLines,
  chevronDown: faChevronDown,
  chevronRight: faChevronRight,
  chevronDoubleRight: faChevronsRight,
  signOut: faArrowRightFromBracket,
  print: faPrint,
  chevronLeft: faChevronLeft,
  chevronDoubleLeft: faChevronsLeft,
  mobilePhone: faMobileScreen,
  phoneOutline: phoneRegular,
  processed: faCheckToSlot,
  openBox: faBoxOpenRegular,
  ellipsis: faEllipsis,
  text: faText,
  chevronUp: faChevronUp,
  phone: faPhone,
  empty: faBoxOpen,
  orderRequests: faDiagramVenn,
  jobs: faTools,
  plus: faPlus,
  notification: faStickyNote,
  view: faEye,
  hidden: faEyeSlash,
  grid: faGrid,
  table: faTable,
  stock: faCrateEmpty,
  file: faFile,
  image: faImage,
  link: faLink,
  unlink: faLinkHorizontalSlash,
  associated: faNetworkWired,
  productLocations: faLocationArrow,
  warehouses: faBoxes,
  productGroups: faObjectGroup,
  categories: faObjectsAlignBottom,
  brands: faFingerprint,
  warehouseFull: faWarehouseFull,
  notificationBell: faBell,
  notificationBellS: faBellSolid,
  read: faEnvelopeOpen,
  changesApproved: faClipboardListCheck,
  internalTickets: faCommentLines,
  crm: faBookCopy,
  varianceReport: faFileChartColumn,
  contacts: faIdBadge,
  merge: faCodeMerge,
  x: faTimes,
  xSolid: faTimesSolid,
  undo: faRotateLeft,
  tasks: faListCheck,
  feature: faStar,
  toggleOn: faToggleOn,
  toggleOff: faToggleOff,
  manufacturers: faConveyorBelt,
  customerSupport: faCommentsQuestion,
  serialNumbers: faBarcode,
  run: faPersonRunning,
  circleCheck: faCircleCheck,
  circleMinus: faCircleMinus,
  addressBook: faAddressBook,
  cart: faCartShopping,
  cartS: faCartShoppingSolid,
  pdf: faFilePdf,
  xls: faFileExcel,
  filter: faFilter,
  lineOfBusiness: faPhoneArrowDownLeft,
  task: faTasks,
  notes: faNote,
  projects: faNote,
  salesReps: faUserTieHair,
  alerts: faExclamationCircle,
  targets: faBullseye,
  stockTakes: faClipboardList,
  customerSlideshow: faPresentation,
  tradeApplications: faFileLines,
  login: faRightToBracket,
  supportAndReturns: faConveyorBeltBoxes,
  returnRequests: faSquareThisWayUp,
  warning: faTriangleExclamation,
  stockTransfers: faArrowRightArrowLeft,
  priceBands: faMoneyCheck,
  sharedPriceBands: faMoneyBill1,
  universalPriceBands: faGlobe,
  fileAdd: faFilePlus,
  arrowLeftLong: faArrowLeftLong,
  arrowRightLong: faArrowRightLong,
  bulkEmail: faMailBulk,
  tags: faTags,
  slidersUp: faSlidersUp,
  close: faXmark,
  holidayRequests: faCalendarClock,
  hr: faBuildings,
  illness: faFaceThermometer,
  staffChanges: faClipboardUser,
  memo: faMemo,
  loginAsUser: faCow,
  changelog: faStar,
  purchaseRequisition: faCodePullRequest,
  siteBanner: faFlagPennant,
  mailchimp: faMonkey,
  customerList: faList,
  user: faUser,
  circleCross: faCircleXmark,
  favourite: faStar,
  unfavourite: faStarDuo,
  collect: faTruckPickup,
  pendingPicks: faTruckClock,
  buyingGroups: faUsersViewfinder,
  approveMargin: faMoneyCheck,
  kits: faRectangleHistory,
  folder: faFolder,
  bomItems: faListDropdown,
  fileGenerations: faFileExport,
  split: faSplit,
  reportEvents: faFileChartColumn,
  logs: faFileLines,
  bookIn: faBoxOpen,
  roles: faLayerGroup,
  faChevronLeftRegular: faChevronLeftRegular,
  faChevronRightRegular: faChevronRightRegular,
  import: faUpload,
  customerPageBanners: faPager,
  align: faObjectsAlignBottom,
  share: faShare,
  signIn: faRightToBracket,
  register: faUser,
}
